<template>
    <a-button class="m-b-20" @click="openGoods" type="primary">添加商品</a-button>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:product_name="{record}">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
          </template>
          <template #description>
            <p class="s_omit2" style="width:200px">{{record.product_name}}</p>
            <p class="s_omit2" style="width:200px">{{record.sku_name}} </p>
          </template>
        </a-card-meta>
      </template>
      <template v-slot:value="{ record }">
        <a-input-number v-model:value="record.point_price" :precision="0" @blur="(e)=>changePoint(e,record)"></a-input-number>
      </template>
      <template v-slot:action="{ record }">
        <a @click="del(record)" href="javascript:;">删除</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    <a-modal title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose >
      <selectOnlineSkuGoods v-on:select="goodSelect" :selectList='goodList' :checkout="true" :beSelectGoodsKeys="beSelectGoodsKeys"></selectOnlineSkuGoods>
    </a-modal>
    <a-modal :maskClosable="false" title="输入积分" v-model:visible="showGoodPoint" centered :width='1300'  destroyOnClose @ok="confirmGoods" @cancel="cancelConfirmGoods">

      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='goodList'>
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p class="s_omit2" style="width:200px">{{record.product_name}}</p>
              <p class="s_omit2" style="width:200px">{{record.sku_name}} ({{record.key==0?'单件':'整箱'}})</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:value="{ record }">
          <a-input-number v-model:value="record.value" :precision="0"></a-input-number>
        </template>
        <template v-slot:action="{ index }">
          <a @click="delNewGood(index)" href="javascript:;">删除</a>
        </template>
      </a-table>
    </a-modal>
</template>

<script>
import useTableSearch from "@/hooks/useTableSearch";
import {
  detailGoodsPriceTem,
  delGoodsPriceTemDel,
  editGoodsPriceTemPoint,
  addGoodsPriceTemPoint,
  detailAllGoodsPriceTem
} from "@/api/online";
import store from "@/store";
import { onMounted, ref } from "@vue/runtime-core";
import { iscode } from "../../../../utils/app";
import { message, Modal } from "ant-design-vue";
const def = {
  limit: 10,
  page: 1,
};
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props) {
    let columns = [
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
        width: 300,
        slots: { customRender: "product_name" },
      },
      {
        title: "商品分组",
        dataIndex: "category_name",
        key: "category_name",
      },
      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
      {
        title: "支付积分",
        dataIndex: "product_price",
        key: "product_price",
        slots: { customRender: "value" },
      },
      {
        title: "商品状态",
        dataIndex: "goods_status_text",
        key: "goods_status_text"
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      listLoading,
    } = useTableSearch({
      data: {
        ...def,
        id: props.options.id,
      },
    });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(detailGoodsPriceTem, search.value);
      getSelectData()
    });

    // 修改积分
    const changePoint = async (e, data) => {
      let result = await editGoodsPriceTemPoint(data.id, {
        point_price: data.point_price,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        tableHoosks.initData(detailGoodsPriceTem, search.value);
      }
    };
    // 删除
    const del = (data) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await delGoodsPriceTemDel(data.id).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            tableHoosks.initData(detailGoodsPriceTem, search.value);
                  getSelectData()
          }
        },
      });
    };
    // 选择商品
    const goodsHooks = function () {
      const showGood = ref(false);
      const showGoodPoint = ref(false);
      const goodList = ref([]);
      // 开启弹窗
      const openGoods = () => {
        showGood.value = true;
      };
      const goodSelect = (data) => {
        showGood.value = false;
        showGoodPoint.value = true;
        goodList.value = data;
      };
    //删除
    const delNewGood=(index)=>{
        goodList.value.splice(index,1)
    }
      // 添加商品
      const confirmGoods = async() => {
           if (goodList.value.filter((v) => v.value).length !=goodList.value.length) {
            message.error("支付积分请填写完整");
            return
          }
         var tem_goods_data = [];
          goodList.value.forEach((v) => {
            console.log(v)
            tem_goods_data.push({
              key: v.goods_id+'-'+v.sku_id+'-'+v.key,
              value: v.value ||v.point_price,
            });
          });
        let result=await  addGoodsPriceTemPoint(props.options.id,{tem_goods_data}).then(res=>res.data).catch(error=>error)
        if(iscode(result,true)){
            search.value.page = 1;
            tableHoosks.initData(detailGoodsPriceTem, search.value);
            showGoodPoint.value = false;
            goodList.value=[]
            getSelectData()
        }
      };
        const cancelConfirmGoods=()=>{
           showGoodPoint.value = false;
           goodList.value=[]
      }
      return {
        showGood,
        openGoods,
        goodList,
        goodSelect,
        showGoodPoint,
        confirmGoods,
        cancelConfirmGoods,
        delNewGood
      };
    };
    const { showGood,delNewGood,cancelConfirmGoods, openGoods, goodList, goodSelect, showGoodPoint,confirmGoods } =
      goodsHooks();

      // 获取 已被 选择的商品 de keys
    const beSelectGoodsKeys=ref([])
    const getSelectData=async()=>{
     let result=await  detailAllGoodsPriceTem(props.options).then(res=>res.data).catch(error=>error)
     beSelectGoodsKeys.value=result.data
    }
    
    return {
      info: store.state.user.info,
      ...tableHoosks,
      columns,
      showGood,
      openGoods,
      goodList,
      goodSelect,
      showGoodPoint,
      delNewGood,
      confirmGoods,
      changePoint,
      beSelectGoodsKeys,
      cancelConfirmGoods,
      del
    };
  },
};
</script>